var ltr6_module_content = (function (ltr6_module_content) {

    ltr6_module_content.init = function(){

      // ------------------------------------------------------------------------------------------------------
      // click icon feedback
      // ------------------------------------------------------------------------------------------------------
      if($("#ltr6-wrapper .ltr6-section-feedback").length){

        // var element = $("#ltr6-wrapper .ltr6-section-feedback .ltr6-stay-connected-button .click_icon");
        // var article28signupclasses = element.attr('class');
        // ltr6_module_utilities.inlineSvg(element,function(svg){
        //   svg.attr('class',article28signupclasses); //put same classes on the new content
        //   var tl = new TimelineMax({repeat:-1});
        //   tl.fromTo(svg.find('#ring'),2,{x:"-=0%",y:"-=0%",scale:1,opacity:1},{x:"-=7px",y:"-=8px",scale:2,opacity:0,ease:Power4.easeOut},0);
        // });

        // var element = $("#ltr6-wrapper .ltr6-section-feedback .ltr6-feedback-button .click_icon");
        // var article28classes = element.attr('class');
        // ltr6_module_utilities.inlineSvg(element,function(svg){
        //   svg.attr('class',article28classes); //put same classes on the new content
        //   var tl = new TimelineMax({repeat:-1});
        //   tl.fromTo(svg.find('#ring'),2,{x:"-=0%",y:"-=0%",scale:1,opacity:1},{x:"-=7px",y:"-=8px",scale:2,opacity:0,ease:Power4.easeOut},0);
        // });

        var svg = $("#ltr6-wrapper .ltr6-section-feedback .ltr6-stay-connected-button .click_icon");
        // var article28signupclasses = element.attr('class');
        // ltr6_module_utilities.inlineSvg(element,function(svg){
          // svg.attr('class',article28signupclasses); //put same classes on the new content
          var tl = new TimelineMax({repeat:-1});
          tl.fromTo(svg.find('#ring'),2,{x:"-=0%",y:"-=0%",scale:1,opacity:1},{x:"-=7px",y:"-=8px",scale:2,opacity:0,ease:Power4.easeOut},0);
        // });

        var svg2 = $("#ltr6-wrapper .ltr6-section-feedback .ltr6-feedback-button .click_icon");
        // var article28classes = element.attr('class');
        // ltr6_module_utilities.inlineSvg(element,function(svg){
          // svg2.attr('class',article28classes); //put same classes on the new content
          var tl = new TimelineMax({repeat:-1});
          tl.fromTo(svg2.find('#ring'),2,{x:"-=0%",y:"-=0%",scale:1,opacity:1},{x:"-=7px",y:"-=8px",scale:2,opacity:0,ease:Power4.easeOut},0);
        // });


      }




      // var returnedFunction = ltr6_module_utilities.debounce(function() {
      //     // var screenWidth = ;
      //     // console.log(window.innerHeight > window.innerWidth);
      //     if(window.innerHeight > window.innerWidth){
      //       $('#ltr6-wrapper .ltr6-factoid-portrait').show();
      //       $('#ltr6-wrapper .ltr6-factoid-landscape').hide();
      //     } else {
      //       $('#ltr6-wrapper .ltr6-factoid-portrait').hide();
      //       $('#ltr6-wrapper .ltr6-factoid-landscape').show();
      //     }
      // }, 250);
      // window.addEventListener('resize', returnedFunction);



      // go to trend
      $('#ltr6-wrapper').on('click', '.ltr6-go-to-trend', function(event) {
        event.preventDefault();
        var slug = $(this).attr('data-trend');
        ltr6_module_panzoom.goToTrend(slug);
      });





      //  usabilla

      $('#fowtr-wrapper .ltr6-stay-connected-button').click(function(event) {
        event.preventDefault();
        try {
          window.usabilla_live('trigger', 'ltr6_survey_trigger');
          $(this).addClass('disabled');
        } catch(e) {
          console.warn('usabilla_live not found');
        }
      });


      // event callback
      try {
        resetUsabilla();
        window.usabilla_live('setEventCallback', function(category, action, label, value, userData){
          console.log('setEventCallback',action);
          if(action === "Campaign:Success" || action === "Campaign:Close") {
            resetUsabilla();
          }
        });
      } catch(e) {
        console.warn('usabilla_live not found');
      }


      function resetUsabilla(){
        try {
          var arr = [];
          for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).substring(0,18) == 'usbl.b2d2adfa16cf.') {
              arr.push(localStorage.key(i));
            }
          }
          for (var i = 0; i < arr.length; i++) {
            localStorage.removeItem(arr[i]);
          }
        } catch(e) {
          console.warn('usabilla_live not found');
        }
      }
      resetUsabilla();
      $(window).on('beforeunload', function(){
        resetUsabilla();
      });

      // end usabilla

    };

    return ltr6_module_content;
}(ltr6_module_content || {}));



